module.exports = __webpack_public_path__ + "static/media/resumeBlogThumbnail.901de55a.jpg";